import type { BadgeProps } from '@passkeys/ui/badge';
import Badge from '@passkeys/ui/badge';

import { cn } from '@/ui/utils/classnames';

const CONFIG_BY_STATUS = {
  pending: { label: 'Pending', variant: 'yellow' },
  completed: { label: 'Completed', variant: 'green' },
  failed: { label: 'Failed', variant: 'red' },
} as const;

type StatusValue = keyof typeof CONFIG_BY_STATUS;

type StatusProps = BadgeProps & {
  value: StatusValue | null;
  size?: 'small' | 'medium';
  className?: string;
  dataTestId?: string;
};

function ActivityStatus({
  value,
  size = 'medium',
  className,
  dataTestId,
}: StatusProps) {
  if (!value) {
    return null;
  }

  const { variant, label } = CONFIG_BY_STATUS[value];

  return (
    <Badge
      variant={variant}
      className={cn(
        'uppercase',
        size === 'small' &&
          'h-auto px-[6px] text-[0.5625rem] uppercase leading-4',
        className,
      )}
      dataTestId={dataTestId}
    >
      {label}
    </Badge>
  );
}

export default ActivityStatus;
